var _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 31,
    viewBox: "0 0 53 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 28.5C13 21.0442 19.0442 15 26.5 15C33.9558 15 40 21.0442 40 28.5V31H13V28.5Z",
    fill: "#2E732F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 7,
    r: 7,
    fill: "#2E732F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.0649C0 23.2926 4.67935 18.6133 10.4516 18.6133C16.2239 18.6133 20.9032 23.2926 20.9032 29.0649V31.0004H0V29.0649Z",
    fill: "#2E732F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0639,
    cy: 12.4194,
    r: 5.41935,
    fill: "#2E732F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29.0649C32 23.2926 36.6793 18.6133 42.4516 18.6133C48.2239 18.6133 52.9032 23.2926 52.9032 29.0649V31.0004H32V29.0649Z",
    fill: "#2E732F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0639,
    cy: 12.4194,
    r: 5.41935,
    fill: "#2E732F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeMan);
export default __webpack_public_path__ + "static/media/ThreeMan.615d270b3a677a03b546ebdc644ccd10.svg";
export { ForwardRef as ReactComponent };